import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Overview from "./pages/Overview";
import Media from "./pages/Media";
import Playlists from "./pages/Playlists";
import Logs from "./pages/Logs";
import Guide from "./pages/Guide";
import SampleAds from "./pages/SampleAds";
import Sports from "./pages/Sports";
import Themes from "./pages/Themes";
import Ads from "./pages/Ads";
import AiSlides from "./pages/AiSlides";
import AiClips from "./pages/AiClips";
import AiDirector from "./pages/AiDirector";
import WeeklyAds from "./pages/WeeklyAds";
import BrandSettings from "./pages/BrandSettings";
import Player from "./pages/Player";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/player" element={<Player />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Overview />} />
        <Route path="media" element={<Media />} />
        <Route path="ai-slides" element={<AiSlides />} />
        <Route path="ai-clips" element={<AiClips />} />
        <Route path="ai-director" element={<AiDirector />} />
        <Route path="weekly-ads" element={<WeeklyAds />} />
        <Route path="samples" element={<SampleAds />} />
        <Route path="playlists" element={<Playlists />} />
        <Route path="sports" element={<Sports />} />
        <Route path="themes" element={<Themes />} />
        <Route path="ads" element={<Ads />} />
        <Route path="logs" element={<Logs />} />
        <Route path="brand" element={<BrandSettings />} />
        <Route path="guide" element={<Guide />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
